export default "__VITE_ASSET__BARcDrvf__"